import React from "react";
import "./Contct.css";


function Contact() {
  return (
    <div>
      <div className="row banner">
        <div className="bannerinside">
          <div className="headtitle">
            <div className="title-icon">
              <span className="icon-ring">
                <img src="./images/image.png" alt="Darshan" />
              </span>
            </div>

            <div className="title-content">
              <span className="title-small">TEMPLE</span>
              <h2 className="texthead">Contact</h2>

              <div className="title-divider">
                <span></span>
                <i>✦</i>
                <span></span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container" style={{ marginTop: '100px', marginBottom: '100px' }}>

        <div className="contact-location-section">

  <div className="contact-location-container">

    {/* LEFT - CONTACT DETAILS */}
    <div className="contact-details">

      <div className="contact-heading">

        <span className="contact-eyebrow">
          GET IN TOUCH
        </span>

        <h2>
          Contact <span>Us</span>
        </h2>

        <p>
          For enquiries, assistance and official communication,
          please contact the temple office.
        </p>

      </div>


      {/* Address */}
      <div className="contact-info-card">

        <div className="contact-info-icon">
          <i className="fa fa-map-marker"></i>
        </div>

        <div className="contact-info-content">

          <span>OFFICE ADDRESS</span>

          <p>
            <strong>The Executive Officer</strong>
            <br />
            Ulsavamadam Building, North Nada
            <br />
            Sree Padmanabha Swamy Temple Fort,
            <br />
            Thiruvananthapuram – 695023.
          </p>

        </div>

      </div>


      {/* Phone */}
      <div className="contact-info-card">

        <div className="contact-info-icon">
          <i className="fa fa-phone"></i>
        </div>

        <div className="contact-info-content">

          <span>PHONE</span>

          <a href="tel:04712450233">
            0471-2450233
          </a>

        </div>

      </div>


      {/* Email */}
      <div className="contact-info-card">

        <div className="contact-info-icon">
          <i className="fa fa-envelope"></i>
        </div>

        <div className="contact-info-content">

          <span>EMAIL</span>

          <a href="mailto:mathilakamofficespst@gmail.com">
            mathilakamofficespst@gmail.com
          </a>

          <a href="mailto:catoeospst@gmail.com">
            catoeospst@gmail.com
          </a>

        </div>

      </div>


      {/* Small bottom message */}
      <div className="contact-note">

        <i className="fa fa-info-circle"></i>

        <span>
          Please contact the office during official working hours
          for assistance.
        </span>

      </div>

    </div>


    {/* RIGHT - MAP */}
    <div className="contact-map">

      <iframe
        title="Sree Padmanabhaswamy Temple Location"
        src="https://www.google.com/maps/embed?pb=!1m28!1m12!1m3!1d25766.17342509899!2d76.93976575387063!3d8.476575175348014!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m13!3e6!4m5!1s0x3b05bb09b7e81d35%3A0x1d2fedb7213a1ef7!2sSree%20Padmanabhaswamy%20Temple%2C%20Sree%20Padmanabha%20Swamy%20Temple%2C%20West%20Nada%2C%20Fort%2C%20East%20Fort%2C%20Pazhavangadi%2C%20Thiruvananthapuram%2C%20Kerala!3m2!1d8.4827779!2d76.9435906!4m5!1s0x3b05bb09b7e81d35%3A0x1d2fedb7213a1ef7!2sWest%20Nada%2C%20Fort%2C%20East%20Fort%2C%20Pazhavangadi%2C%20Thiruvananthapuram%2C%20Kerala%20695023!3m2!1d8.4827779!2d76.9435906!5e0!3m2!1sen!2sin!4v1757915200134!5m2!1sen!2sin"
        loading="lazy"
        allowFullScreen
      />

      {/* Map overlay */}
      <div className="map-location-card">

        <div className="map-location-icon">
          <i className="fa fa-map-marker"></i>
        </div>

        <div>
          <span>OUR LOCATION</span>
          <strong>Sree Padmanabhaswamy Temple</strong>
          <small>Thiruvananthapuram, Kerala</small>
        </div>

      </div>


      {/* Directions */}
      <a
        href="https://www.google.com/maps/search/?api=1&query=Sree+Padmanabhaswamy+Temple+Thiruvananthapuram"
        target="_blank"
        rel="noopener noreferrer"
        className="map-directions"
      >
        <i className="fa fa-location-arrow"></i>
        Get Directions
      </a>

    </div>

  </div>

</div>


      </div>
    </div>
  );
}

export default Contact;